/* Cart Net Patch (GLOBAL, survives empty cart)
   - Runs on all pages (safe), but only acts on cart page or cart-drawer if present
   - Never fetches myshopify cart.js (no CORS)
*/

(function cartNetPatchOnce() {
  if (window.__CART_NET_PATCHED__) return;
  window.__CART_NET_PATCHED__ = true;

  function isCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  function isCartMutationUrl(url) {
    if (!url) return false;
    const u = String(url);
    return (
      u.includes('/cart/add') ||
      u.includes('/cart/change') ||
      u.includes('/cart/update') ||
      u.includes('/cart/clear')
    );
  }

  function isCartJsonResponseUrl(url) {
    if (!url) return false;
    const u = String(url);
    return (u.includes('/cart/change') || u.includes('/cart/update') || u.includes('/cart/clear'));
  }

  // ----- Cart page refresh (sections API)
  function getMainCartSectionIdFromDom() {
    const cartForm = document.getElementById('cart');
    const root = cartForm ? cartForm.closest('.shopify-section[id^="shopify-section-"]') : null;
    if (!root) return null;
    return root.id.replace('shopify-section-', '');
  }

  let cartPageRefreshInFlight = null;
  let cartPageRefreshAt = 0;

  async function refreshCartPageSection() {
    if (!isCartPage()) return;

    const sectionId = getMainCartSectionIdFromDom();
    if (!sectionId) return;

    const now = Date.now();
    if (now - cartPageRefreshAt < 120) return; // throttle
    cartPageRefreshAt = now;

    if (cartPageRefreshInFlight) return cartPageRefreshInFlight;

    cartPageRefreshInFlight = (async () => {
      const url = `${window.location.pathname}?sections=${encodeURIComponent(sectionId)}`;
      const res = await fetch(url, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!res.ok) return;

      const json = await res.json();
      const html = json[sectionId];
      if (!html) return;

      const currentRoot = document.getElementById(`shopify-section-${sectionId}`);
      if (!currentRoot) return;

      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;

      const newRoot = tmpl.content.querySelector(`#shopify-section-${sectionId}`);
      if (!newRoot) return;

      currentRoot.replaceWith(newRoot);

      // payment buttons
      if (window.Shopify?.PaymentButton?.init) window.Shopify.PaymentButton.init();

      // dependent UI signals (FSN etc.)
      window.requestAnimationFrame(() => {
        document.dispatchEvent(new CustomEvent('cart:rendered'));
        if (typeof window.__FSN_UPDATE__ === 'function') window.__FSN_UPDATE__();
      });
    })().finally(() => {
      cartPageRefreshInFlight = null;
    });

    return cartPageRefreshInFlight;
  }

  // ----- Drawer support (if exists)
  function syncDrawerFromCount(count) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (typeof drawer.applyHeaderCount === 'function') drawer.applyHeaderCount(count);
    if (typeof drawer.fireCartRendered === 'function') drawer.fireCartRendered({ reset: false });

    setTimeout(() => {
      if (typeof drawer.syncHeaderCount === 'function') drawer.syncHeaderCount({ aggressive: true, preferFetch: true });
      if (typeof drawer.fireCartRendered === 'function') drawer.fireCartRendered({ reset: false });
    }, 120);

    if (Number(count) === 0 && typeof drawer.refresh === 'function') drawer.refresh(true);
  }

  function afterCartMutationFromJson(data) {
    const c = Number(data?.item_count);
    if (Number.isFinite(c)) {
      // drawer varsa sync
      if (document.querySelector('cart-drawer')) syncDrawerFromCount(c);

      // cart page ise refresh
      if (isCartPage()) {
        refreshCartPageSection();
        setTimeout(refreshCartPageSection, 160);
      }
      return;
    }

    // fallback
    if (isCartPage()) {
      refreshCartPageSection();
      setTimeout(refreshCartPageSection, 160);
    }
  }

  function afterCartMutationFallback() {
    if (isCartPage()) {
      refreshCartPageSection();
      setTimeout(refreshCartPageSection, 160);
    }
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.refresh === 'function') {
      // drawer tarafında zaten kendi içinde sync mekanizman var
      drawer.refresh(false);
    }
  }

  // ---- Fetch patch
  if (window.fetch) {
    const origFetch = window.fetch;

    window.fetch = function patchedFetch(input, init) {
      const url = (typeof input === 'string') ? input : (input && input.url) ? input.url : '';
      const method = (init && init.method) ? String(init.method).toUpperCase() : 'GET';
      const isMutation = isCartMutationUrl(url) && method !== 'GET';

      return origFetch.apply(this, arguments).then((res) => {
        if (!isMutation) return res;

        if (isCartJsonResponseUrl(url)) {
          try {
            res.clone().json().then(afterCartMutationFromJson).catch(afterCartMutationFallback);
          } catch (e) {
            afterCartMutationFallback();
          }
          return res;
        }

        // add.js etc.
        try { Promise.resolve().then(afterCartMutationFallback); } catch (e) { afterCartMutationFallback(); }
        return res;
      });
    };
  }

  // ---- XHR patch
  try {
    const XHR = window.XMLHttpRequest;
    if (XHR && XHR.prototype && !XHR.prototype.__cartPatched) {
      XHR.prototype.__cartPatched = true;

      const origOpen = XHR.prototype.open;
      const origSend = XHR.prototype.send;

      XHR.prototype.open = function (method, url) {
        this.__isCartMutation = isCartMutationUrl(url) && String(method || '').toUpperCase() !== 'GET';
        this.__isCartJsonUrl = isCartJsonResponseUrl(url);
        return origOpen.apply(this, arguments);
      };

      XHR.prototype.send = function () {
        if (this.__isCartMutation) {
          this.addEventListener('loadend', () => {
            if (this.__isCartJsonUrl) {
              try {
                const data = JSON.parse(this.responseText || '{}');
                afterCartMutationFromJson(data);
              } catch (e) {
                afterCartMutationFallback();
              }
            } else {
              afterCartMutationFallback();
            }
          });
        }
        return origSend.apply(this, arguments);
      };
    }
  } catch (e) {
    // ignore
  }
})();
